import { ApolloProvider } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { apolloClient } from '~/apollo/client-v3';
import { ToastifyContainer } from '~/components/ToastifyContainer';
import { router } from '~/router';

import 'react-toastify/dist/ReactToastify.css';
import '~/global.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ToastifyContainer />
    <ApolloProvider client={apolloClient}>
      <RouterProvider router={router} />
    </ApolloProvider>
  </React.StrictMode>,
);
